import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonMenu } from './Menu.definition';
import { chameleonMenuItem } from './MenuItem/MenuItem.definition';
import { chameleonMenuSection } from './MenuSection/MenuSection.definition';
import { chameleonMenuSeparator } from './MenuSeparator/MenuSeparator.definition';
provideChameleonDesignSystem().register(chameleonMenu(), chameleonMenuItem(), chameleonMenuSeparator(), chameleonMenuSection());
